import { t } from 'i18next'
import { useAppStore } from '../../stores/RootStore'
import { Button } from '../../ui/Button'
import AI from '../../components/AI/AI'

export default function HomePage() {
  const { currentSite } = useAppStore()
  return (
    <div className="px-6 mx-auto flex flex-col py-6">
      <div className="flex-none h-32 max-w-[1008px] flex flex-col justify-center items-center gap-1">
        <img src="../logo_F7.png" className="h-6 mb-1" />
        <div className="text-xs text-foreground opacity-60">
          {t('for_company')}
        </div>
        <div className="text-sm font-medium">{currentSite?.name}</div>
      </div>
      {/* <AI /> */}
      <div className="flex flex-col max-w-[1008px] h-full">
          <div className="h-full flex flex-col items-center justify-center">
              <div className="flex flex-col w-full justify-center mb-20 gap-2">
                  <div className="text-4xl text-center font-semibold w-full">Узнайте все о Вашем предприятии</div>
                  <div className="text-sm text-center text-muted-foreground w-1/2 mx-auto">Спросите что хотите узнать или воспользуйтесь быстрыми подсказками</div>
              </div>
              <div className="flex flex-col w-full justify-center items-center gap-4">
                  <div className="text-sm text-center text-muted-foreground w-1/2 mx-auto">Что хотите узнать?</div>
                  <div className="flex gap-4 w-full">
                      <Button variant={"secondary"} className="w-1/3 rounded text-left h-12">
                          <div className="text-sm text-wrap leading-5">Какое оборудование сейчас загружено?</div>
                      </Button>
                      <Button variant={"secondary"} className="w-1/3 rounded text-left h-12">
                          <div className="text-sm text-wrap leading-5">Сколько сотрудников сейчас работает?</div>
                      </Button>
                      <Button variant={"secondary"} className="w-1/3 rounded text-left h-12">
                          <div className="text-sm text-wrap leading-5">Какое оборудование сейчас в простое?</div>
                      </Button>
                  </div>
                  <div className="flex gap-4">
                      <Button variant={"secondary"} className="w-1/3 rounded text-left h-12">
                          <div className="text-sm text-wrap leading-5">Сколько сегодня было переналадок?</div>
                      </Button>
                      <Button variant={"secondary"} className="w-1/3 rounded text-left h-12">
                          <div className="text-sm text-wrap leading-5">Какое оборудование работало без сотрудника?</div>
                      </Button>
                      <Button variant={"secondary"} className="w-1/3 rounded text-left h-12">
                          <div className="text-sm text-wrap leading-5">Какое оборудование сейчас в простое?</div>
                      </Button>
                  </div>
                  <Button variant={"outline"} size={"xs"} className="max-w-min">
                      Все подсказки
                  </Button>
              </div>
          </div>
          <div className="flex-none h-40">
              <div className="h-8 w-full flex justify-between items-center mb-2">
                  <Button variant={"outline"} size={"xs"} className="max-w-min">
                      Все подсказки
                  </Button>
                  <div className="text-xs text-muted-foreground">Для поиска нажмите ⌘K</div>
              </div>
              <div className="h-24 bg-muted rounded">

              </div>
          </div>
      </div>
    </div>
  )
}
